import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "disabled", "readOnly", "hasError", "hint", "legend", "label", "id", "name"];
import React, { forwardRef } from 'react';
import Col from '../Col';
import Row from '../Row';
import Box from '../Box';
import Label from '../Label';
import SuperFieldHint from '../SuperFieldHint';
export var getVariant = function getVariant(_ref) {
  var hasError = _ref.hasError,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled;

  if (hasError) {
    return 'danger';
  }

  if (disabled || readOnly) {
    return 'disabled';
  }
};
var FormGroup = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      disabled = _ref2.disabled,
      readOnly = _ref2.readOnly,
      hasError = _ref2.hasError,
      hint = _ref2.hint,
      legend = _ref2.legend,
      label = _ref2.label,
      id = _ref2.id,
      name = _ref2.name,
      rest = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    as: "fieldset",
    variant: getVariant({
      hasError: hasError,
      readOnly: readOnly,
      disabled: disabled
    }),
    sx: {
      border: 'none',
      appearance: 'none',
      p: 0
    }
  }, /*#__PURE__*/React.createElement(Row, _extends({
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center"
  }, rest), /*#__PURE__*/React.createElement(Col, {
    span: [12, 12, 5, 4],
    pb: [2, 2, 0]
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: legend ? void 0 : id,
    as: legend ? 'legend' : 'label',
    sx: {
      width: '100%',
      p: 0
    }
  }, legend || label)), /*#__PURE__*/React.createElement(Col, {
    span: [12, 12, 7, 8]
  }, children)), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    span: 12
  }, hint ? /*#__PURE__*/React.createElement(SuperFieldHint, null, hint) : null)));
});
FormGroup.displayName = 'FormGroup';
export default FormGroup;